import { PanelDesignTokens } from '@primeuix/themes/types/panel';

export const panelPreset: PanelDesignTokens = {
  root: {
    borderRadius: '0',
    color: 'var(--gray-1)',
  },
  toggleableHeader: {
    padding: '16px 20px',
  },
  css: () => `
   .p-panel-toggleable{
      border : none;
    }
    /* correction alignbement du bouton */
    .p-panel-toggleable .p-panel-icons {
        display : flex
    }
  `
};
